import React from 'react';
import { useTranslation } from 'react-i18next';

const NoData = () => {
  const { i18n, t } = useTranslation();

  return (
    <div className=" text-xs xxs:text-sm xs:text-xl text-center w-full my-[65px] xs:my-[77px] lg:my-[102px] ">
      {t('게시물이 없습니다')}
    </div>
  );
};

export default NoData;
